// Per-document results of a proposal or a job (decision 3) — OUR wording per status. The filenames are the user's.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { docStatusCopy } from './assistCopy.js';
import { COLORS } from '../../../constants/theme.js';

export default function DocResults({ documents }) {
  const { t } = useTranslation('context');
  if (!Array.isArray(documents) || documents.length === 0) return null;
  return (
    <div style={{ marginTop: '10px', fontSize: '12px', color: COLORS.textSecondary }}>
      <div style={{ fontWeight: 600, marginBottom: '4px' }}>{t('personas.assist.docsResults')}</div>
      <ul style={{ margin: 0, paddingLeft: '18px' }}>
        {documents.map((d, i) => (
          <li key={`${d?.filename || ''}-${i}`}><strong>{d?.filename}</strong>: {docStatusCopy(t, d)}</li>
        ))}
      </ul>
    </div>
  );
}
